// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wf3N","inner":"Footer_inner__mhNib"};